/*
 * EXPORTS
 */
export const chartStyle = {
  'padding': 22,
  'maxWidth': '460px',
  'margin': 'auto'
}
